const TRUSTPILOT_REVIEW_NUMBER = 100000;
export const TRUSTPILOT_REVIEW_COUNT = new Intl.NumberFormat('en-GB').format(TRUSTPILOT_REVIEW_NUMBER);
export const TRUSTPILOT_REVIEW_SEARCH_KEY = '{reviews}';
